/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create and manage API keys to authenticate with the oneAI API from scripts, CLI, or other apps. On paid plans, usage through an API key or the Microsoft Team..." |
*
* @param {Profile_Security_User_Api_Key_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_description = /** @type {((inputs?: Profile_Security_User_Api_Key_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle und verwalte API-Schlüssel zur Authentifizierung mit der oneAI-API aus Skripten, CLI oder anderen Apps. Auf kostenpflichtigen Plänen wird die Nutzung über einen API-Schlüssel oder den Microsoft-Teams-Bot berechnet, auch für oneAI Standard.")
	return /** @type {LocalizedString} */ ("Create and manage API keys to authenticate with the oneAI API from scripts, CLI, or other apps. On paid plans, usage through an API key or the Microsoft Teams bot is charged, oneAI Standard included.")
});